import firebase from './firebase';
import 'firebase/compat/functions';

const functions = firebase.app().functions("europe-west3");

//if (process.env.NODE_ENV === 'development') {
//    functions.useEmulator('localhost', 5001);
//    console.log('FUNCIONES DE EMULADOR');
//}

export default functions;
